/* eslint-disable react/require-default-props */
// Disabled because, in React 17+ for functional components, default values can be directly assigned in the parameter list.
// Therefore, we don't need to use `defaultProps` for setting default values.

import React from 'react';

interface FeatureIconProps extends React.SVGProps<SVGSVGElement> {
  height?: string | number;
  width?: string | number;
}

function FeatureIcon({
  height = 56,
  width = 56,
  ...props
}: Readonly<FeatureIconProps>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 56 56"
      // Disabled because I don't know how many props this component requires, and there are too many props to specify individually.
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      <path
        fill="#FFF1F0"
        d="M28 .5C43.188.5 55.5 12.812 55.5 28S43.188 55.5 28 55.5.5 43.188.5 28 12.812.5 28 .5"
      />
      <path
        stroke="#FFCCC7"
        d="M28 .5C43.188.5 55.5 12.812 55.5 28S43.188 55.5 28 55.5.5 43.188.5 28 12.812.5 28 .5Z"
      />
      <path
        stroke="#FF4D4F"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M28 23.333V28m0 4.666h.012M39.667 28c0 6.443-5.223 11.666-11.666 11.666S16.334 34.443 16.334 28s5.223-11.667 11.667-11.667c6.443 0 11.666 5.223 11.666 11.667"
      />
    </svg>
  );
}

export default FeatureIcon;
